import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { ArrowUpRight, Flame } from "lucide-react";
import { INVESTMENTS as MOCK_INVESTMENTS } from "../mock";
import { getIcon } from "../lib/icons";
import { getOffers } from "../lib/api";

export default function Categories() {
  const [offers, setOffers] = useState(MOCK_INVESTMENTS);

  useEffect(() => {
    let alive = true;
    getOffers().then((data) => { if (alive && data?.length) setOffers(data); }).catch(() => {});
    return () => { alive = false; };
  }, []);

  return (
    <section id="offers" className="py-20 lg:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="max-w-3xl">
          <div className="inline-flex items-center gap-2 text-[12px] font-bold uppercase tracking-[0.18em] text-[#16d196]">
            <span className="w-1.5 h-1.5 rounded-full bg-[#16d196]" />
            11 investment types · UK-wide
          </div>
          <h2 className="mt-4 text-[36px] lg:text-[56px] font-extrabold leading-[1.05] tracking-[-0.025em] text-[#0d1a2e]">
            Which type of investment{" "}
            <span className="text-[#16d196]">fits you?</span>
          </h2>
          <p className="mt-5 text-[#0d1a2e]/65 text-[16.5px] max-w-2xl leading-relaxed">
            From government-backed gilts to growth-stage VCTs — the Investment Hub
            panel spans every major UK asset class. One free check matches you to the
            two or three best-fit live offers.
          </p>
        </div>

        <div className="mt-12 lg:mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-5">
          {offers.map((inv) => {
            const Icon = getIcon(inv.icon);
            return (
              <Link
                key={inv.slug}
                to={`/investments/${inv.slug}`}
                className="group relative bg-white border border-[#0d1a2e]/10 rounded-2xl p-6 hover:border-[#16d196]/60 hover:shadow-[0_12px_36px_rgba(13,26,46,0.08)] transition-all duration-300"
              >
                {inv.hot && (
                  <div className="absolute top-5 right-5 inline-flex items-center gap-1 text-[10px] uppercase tracking-[0.14em] font-bold text-[#0d1a2e] bg-[#fde68a] rounded-full px-2 py-0.5">
                    <Flame className="w-3 h-3" strokeWidth={2.6} /> HOT
                  </div>
                )}

                <div className="w-12 h-12 rounded-xl bg-[#e3f7ee] flex items-center justify-center group-hover:bg-[#16d196] transition-colors">
                  <Icon className="w-5 h-5 text-[#0d1a2e]" strokeWidth={2.2} />
                </div>

                <h3 className="mt-5 text-[18px] font-extrabold text-[#0d1a2e] leading-tight tracking-tight">
                  {inv.name}
                </h3>
                <p className="mt-1 text-[13.5px] text-[#0d1a2e]/55">{inv.short}</p>

                <div className="mt-5 pt-4 border-t border-[#0d1a2e]/8">
                  <div className="text-[10.5px] uppercase tracking-[0.14em] text-[#0d1a2e]/50 font-bold">
                    Target yield
                  </div>
                  <div className="mt-1 flex items-center justify-between">
                    <div className="text-[15.5px] font-extrabold text-[#0d1a2e]">
                      {inv.yieldRange}
                    </div>
                    <div className="w-7 h-7 rounded-full bg-[#0d1a2e]/5 flex items-center justify-center group-hover:bg-[#16d196] transition-colors">
                      <ArrowUpRight className="w-3.5 h-3.5 text-[#0d1a2e]" strokeWidth={2.4} />
                    </div>
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}
